function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0429 11.79C18.617 11.79 24.1051 8.9677 23.9985 5.90298C23.8918 2.83825 18.6267 0.209961 12.0429 0.209961C5.45905 0.209961 0 2.74127 0 5.90298C0 9.06468 5.43965 11.79 12.0429 11.79ZM11.9944 0.733679C18.0158 0.733679 22.9513 3.06132 23.0094 5.93207C23.0676 8.80282 18.074 11.2662 12.0429 11.2662C6.01174 11.2662 0.862975 8.67674 0.969635 5.85448C1.0763 3.03222 5.94386 0.733679 11.9944 0.733679Z",
  fill: "#0C3BDD"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2285 9.41376C10.8697 9.37497 10.5594 9.31678 10.4625 9.21979C10.2976 9.07431 10.2201 8.81245 10.2201 8.43421V6.55271H13.798V8.44391C13.798 8.81245 13.7107 9.08401 13.5653 9.22949C13.4489 9.32647 13.1581 9.38467 12.7993 9.41376V9.85989H16.1445V9.41376C15.7761 9.37497 15.4852 9.31678 15.3785 9.22949C15.2137 9.08401 15.1264 8.81245 15.1264 8.44391V3.55587C15.1264 3.16793 15.204 2.91577 15.3688 2.77029C15.4755 2.67331 15.7664 2.62482 16.1348 2.58602V2.13989H12.7896V2.58602C13.1484 2.62482 13.4392 2.68301 13.5556 2.77029C13.7107 2.91577 13.7883 3.16793 13.7883 3.55587V5.44708H10.2104V3.55587C10.2104 3.16793 10.2879 2.91577 10.4528 2.77029C10.5594 2.67331 10.86 2.62482 11.2188 2.58602V2.13989H7.87354V2.58602C8.2323 2.62482 8.54258 2.68301 8.63955 2.77029C8.80439 2.91577 8.88196 3.16793 8.88196 3.55587V8.44391C8.88196 8.81245 8.80439 9.08401 8.63955 9.22949C8.53289 9.32647 8.2323 9.38467 7.87354 9.41376V9.85989H11.2188V9.41376H11.2285Z",
  fill: "#0C3BDD"
});
function SvgLogoHvn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHvn);
export default __webpack_public_path__ + "static/media/logo-hvn.3243066de33c5c6e2cccddcd1b0dcc86.svg";
export { ForwardRef as ReactComponent };